import PropTypes from 'prop-types'
import React from 'react'

import CommitteeMember from './CommitteeMember'

import './MemberList.css'

/**
 * Import a number of images.
 *
 * See https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack
 */
const importAll = r => {
   const images = {}

  r.keys().forEach((k, i) => {
    images[k.replace('./', '')] = r(k)
  })

  return images
}

const headshots = importAll(require.context('chicago-council-headshots/dist/img/headshots/', false, /\.(png|jpe?g|svg)$/))


const MemberList = ({members, highlightWard, votes, onClickWard}) => {
  if (!members) {
    return false
  }

  const rows = members.map(member => {
    const marker = (member.ward === highlightWard ? '\u2B50' : '')
    const headshot = headshots[member.id.replace('ocd-person/', '') + '.jpg']
    return (
      <CommitteeMember
        key={member.id}
        member={member}
        marker={marker}
        headshot={headshot}
        votes={votes}
        onClickWard={onClickWard} />
    )
  })

  const voteLabel = votes ? (
    <tr>
      <th colSpan="4"></th>
      <th className="MemberList-votes-header" colSpan={votes.length}>Previous Votes</th>
    </tr>
  ) : false

  const tableClassName = votes ? "MemberList MemberList-has-votes" : "MemberList"

  return (
    <table className={tableClassName}>
      <thead>
        {voteLabel}
        <tr>
          <th></th>
          <th>Ward</th>
          <th className="MemberList-headshot-col"></th>
          <th></th>
          {votes ? (votes.map(vote => <th key={vote.ordinance_id}>{vote.short_title}</th>)) : false }
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  )
}

MemberList.propTypes = {
  members: PropTypes.array,
  highlightWard: PropTypes.number,
  votes: PropTypes.array,
  onClickWard: PropTypes.func
}

export default MemberList



// WEBPACK FOOTER //
// ./src/MemberList.js